import { useState } from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { fetchPurchaseOrderFileUrl } from '../../../services/purchaseOrderFiles';
import { useToast } from '../../../providers/ToastProvider';
import { apiErrorMessage } from '../../../utils/apiError';

interface PurchaseOrderFileLinkProps {
    purchaseOrderId: string;
    fileId: string;
    label: string;
}

// Signed URLs are resolved on demand rather than stored, so the drawer never
// renders a link that has already expired.
export function PurchaseOrderFileLink({
    purchaseOrderId,
    fileId,
    label
}: PurchaseOrderFileLinkProps) {
    const { showToast } = useToast();
    const [isResolving, setIsResolving] = useState(false);

    const open = async () => {
        setIsResolving(true);
        try {
            const { url } = await fetchPurchaseOrderFileUrl(purchaseOrderId, fileId);
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (error) {
            showToast(apiErrorMessage(error, 'Failed to open the document'), 'error');
        } finally {
            setIsResolving(false);
        }
    };

    return (
        <button
            type="button"
            disabled={isResolving}
            onClick={() => {
                void open();
            }}
            className="inline-flex items-center gap-1 underline decoration-gray-300 underline-offset-2 hover:text-gray-900 disabled:opacity-50"
        >
            {isResolving ? 'Opening…' : label}
            <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5 text-gray-400" />
        </button>
    );
}
